import React from 'react'
import {connect} from 'react-redux'
import {fromJS} from 'immutable'

import {
  MESSAGE_TYPES
} from '../config/constants'

import truncateString from '../data/formatters/truncate_string'
import formatMessageTime from '../data/formatters/message_time'

import AdvertisementMessageItem from './advertisement_message_item'

class MessagesAdvertisementBatch extends React.Component {
  constructor (props) {
    super(props)

    this.state = {}

    this.renderMessageBatch = this.renderMessageBatch.bind(this)
    this.renderMessageItem = this.renderMessageItem.bind(this)
  }

  renderMessageItem (side, message, index) {
    return (
      <AdvertisementMessageItem
        key={message.get('key')}
        message={message}
        side={side}
        containerId={this.props.containerId}
        maxBubbleWidth={this.props.maxBubbleWidth}
        shouldShowTriangle={true}/>
    )
  }

  renderMessageBatch (side) {
    const messages = this.props.batch.get('messages') || fromJS([])

    if (messages && messages.size > 0) {
      return messages.map(this.renderMessageItem.bind(this, side))
    }
    else {
      return messages
    }
  }

  renderProfileImage () {
    if (this.props.profileImage) {
      return (
        <div style={{width: 32, height: 32, borderSpacing: 0, verticalAlign: 'top', borderRadius: '50%'}}>
          <div style={{width: 32, height: 32, borderRadius: '50%', backgroundColor: '#BABABA', backgroundImage: `url('${this.props.profileImage}')`, backgroundPosition: 'center', backgroundSize: 'cover'}}/>
        </div>
      )
    }
    else {
      return <div><div style={{width: 32, height: 32, background: '#BABABA', borderRadius: '50%'}}/></div>
    }
  }

  renderUserNameDetail () {
    const userName = truncateString(this.props.userName, 30)
    return userName
  }

  renderUserName () {
    return (
      <div className='message-batch-username'>
        {this.renderUserNameDetail()}
      </div>
    )
  }

  renderLastMessageTime () {
    const time = this.props.batch.get('lastMessageTime')

    return (
      <div className='message-batch-time'>
        {formatMessageTime(time)}
      </div>
    )
  }

  render () {
    if (this.props.currentUser.get('uid') === this.props.batch.get('from')) {
      return (
        <div className='message-batch right'>
          <div>
            {this.renderMessageBatch('receiver')}
            {this.renderLastMessageTime()}
          </div>
        </div>
      )
    }
    else {
      return (
        <div className='message-batch'>
          {this.renderProfileImage()}
          <div>
            {this.renderUserName()}
            {this.renderMessageBatch('sender')}
            {this.renderLastMessageTime()}
          </div>
        </div>
      )
    }
  }
}

const mapStateToProps = (state) => {
  return {
    userName: state.getIn(['advertisements', 'chatBotSlot', 'chatBotName']),
    profileImage: state.getIn(['advertisements', 'chatBotSlot', 'chatBotProfileImage']),
    currentUser: state.get('currentUser', fromJS({}))
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showModal: (modal) => dispatch(showModal(modal))
  }
}

const MessagesAdvertisementBatchContainer = connect(
  mapStateToProps, mapDispatchToProps
)(MessagesAdvertisementBatch)

export default MessagesAdvertisementBatchContainer


/** WEBPACK FOOTER **
 ** ./modules/shared/conversation/messages_advertisement_batch.js
 **/